import * as React from 'react'
import Select, { components, Props as SelectProps } from 'react-select'
import AsyncSelect from 'react-select/async'
import { SortableContainer, SortableElement, SortableContainerProps } from 'react-sortable-hoc'

export function arrayMove(array, from, to) {
  array = array.slice()
  array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0])
  return array
}

const SortableMultiValueBase = SortableElement((props: any) => {
  const onMouseDown = e => {
    e.preventDefault()
    e.stopPropagation()
  }
  const innerProps = { onMouseDown }
  return <components.MultiValue {...props} innerProps={innerProps} />
})

export const SortableMultiValue = SortableMultiValueBase as any

export const SortableAsyncSelect = SortableContainer(AsyncSelect)

const SortableSelectBase = SortableContainer(Select)

const SortableSelect = SortableSelectBase as React.ComponentType<SortableContainerProps & SelectProps>

export default SortableSelect
